<template>
	<div class="container">
	  <!-- 筛选 -->
	  <div>
		<el-form inline :model="filters">
		  <el-form-item :label="$t('Operator')" v-show="zong">
			<el-select
			  v-model="filters.SellerIds"
			  @change="changeSellerIdMore"
			  clearable
			  filterable
			  multiple
			  collapse-tags
			  style="width: 200px"
			  :placeholder="$t('Operator')"
			>
			  <el-option
				v-for="item in userSellerList"
				:key="item.SellerId"
				:label="item.SellerName"
				:value="item.SellerId"
			  >
			  </el-option>
			</el-select>
		  </el-form-item>
		  <el-form-item  :label="$t('ChannelProviders')">
			<el-select
			  v-model="filters.ChannelId"
			  clearable
			  filterable
			  multiple
			  collapse-tags
			 :placeholder="$t('ChannelProviders')"
			  style="width: 200px"
			>
			  <el-option
				v-for="item in channel"
				:key="item.ChannelId"
				:label="item.Name"
				:value="item.ChannelId"
			  >
			  </el-option>
			</el-select>
		  </el-form-item>
		  <el-form-item :label="$t('playerID')">
			<el-input
			  v-model="filters.UserId"
			  style="width: 150px"
			  clearable
			  :placeholder="$t('PlayerIdSearch')"
			>
			</el-input>
		  </el-form-item>
		  <!-- <el-form-item :label="$t('TransactionType')">
			<el-input
			  v-model="selectedLabels"
			  style="width: 150px"
			  clearable
			  :placeholder="$t('SelectType')"
			  @focus="showOrderStateDialog = true"
			  @clear="clearSelection"
			>
			</el-input>
		  </el-form-item> -->
		  <el-form-item :label="$t('Date')">
			<el-date-picker
			  v-model="filters.date"
			  :picker-options="comPickerOptions"
			  type="datetimerange"
			  :default-time="['00:00:00', '23:59:59']"
			  :range-separator="$t('to')"
			  :start-placeholder="$t('startTime')"
			   :end-placeholder="$t('endTime')"
			>
			</el-date-picker>
		  </el-form-item>
		  <el-form-item>
			<el-button
			  type="primary"
			  icon="el-icon-refresh"
			  @click="handleQuery()"
			  >{{$t('Search')}}</el-button
			>
			<!-- <el-button
			  type="primary"
			  icon="el-icon-refresh"
			  @click="(Export = 1), handleQuery()"
			  >{{$t('Export')}}</el-button
			> -->
		  </el-form-item>
		</el-form>
	  </div>
	  <!--表-->
	  <div>
		<el-table
		  :data="table_data"
		  border
		  class="table"
		  :cell-style="{ padding: '3px' }"
		  
		>
		<!-- :summary-method="getSummaries"
		  show-summary -->
		  <el-table-column
			align="center"
			prop="Id"
			label="ID"
			width="70"
			show-overflow-tooltip
		  ></el-table-column>
		  <el-table-column
			align="center"
			prop="Seller"
			:label="$t('Channel')"
			width="100"
			show-overflow-tooltip
		  >
			<template slot-scope="scope" >
			  <span >{{ channelmap[scope.row.ChannelId] }}</span>
			</template>
		  </el-table-column>
		  <el-table-column
			align="center"
			prop="UserId"
			:label="$t('playerID')"
			width="100"
			show-overflow-tooltip
		  ></el-table-column>
		  <el-table-column
			align="center"
			prop="Multiple"
			:label="$t('TurnoverMultiple')"
			width="100"
			show-overflow-tooltip
		  ></el-table-column>
		  <!-- <el-table-column
			align="center"
			prop="Type"
			 width="100"
			:label="$t('type')"
			show-overflow-tooltip
		  >
			<template slot-scope="scope">
			  <span>{{ backLabelValue(scope.row.Reason) }}</span>
			</template>
		  </el-table-column> -->
		  <!-- <el-table-column align="center" prop="Game" :label="$t('eventType')" width="120"
								   show-overflow-tooltip></el-table-column> -->
		  <el-table-column
			align="center"
			prop="Amount"
			:label="$t('ChangeValue')"
			width="80"
			center
			show-overflow-tooltip
		  ></el-table-column>
		  <el-table-column
			align="center"
			prop="BeforeAmount"
			:label="$t('BeforeChange')"
			width="100"
			center
			show-overflow-tooltip
		  ></el-table-column>
		  <el-table-column
			align="center"
			prop="AfterAmount"
			:label="$t('AfterChange')"
			width="100"
			center
			show-overflow-tooltip
		  ></el-table-column>

		  <el-table-column
			align="center"
			:label="$t('AfterChange1')"
			width="100"
			center
			show-overflow-tooltip
		  >
		  	<template slot-scope="scope" >
			  <span >{{ scope.row.AfterAmount - scope.row.BeforeAmount   }}</span>
			</template>
			</el-table-column>
		  <el-table-column
			align="center"
			prop="Memo"
			 :label="$t('Remarks')"
			width="100"
			show-overflow-tooltip
		  ></el-table-column>
		  <el-table-column
			align="center"
			prop="CreateTime"
			 min-width="140"
		   :label="$t('time')"
			show-overflow-tooltip
		  ></el-table-column>
		</el-table>
		<div class="pagination">
		  <el-pagination
			background
			layout="total, sizes,prev, pager, next, jumper"
			@size-change="handleSizeChange"
			:page-sizes="pagesizes"
			:current-page="page"
			:total="total"
			@current-change="handleQuery"
			:page-size="pagesize"
		  >
		  </el-pagination>
		</div>
	  </div>
	  <!--弹窗-->
	 
	</div>
  </template>
  
  <script>
  import { app } from "@/api/app.js";
  import base from "@/api/base.js";
  import { get } from "sortablejs";
  export default {
	extends: base,
	name: "withdrawliushuiHistory",
	props: {
	  extraParams: {
		type: Object,
		default: () => {},
	  },
	},
	data() {
	  return {
		filters: {
		  UserId: null,
		  date: null,
		},
		Export: 0,
		table_data: [],
		totalCount: {},
		showOrderStateDialog: false,
		selectedItems: [],
		selectAll: false,
		deselectAll: false,
		invertSelection: false,
		allChangeTypeList: [],
		changeTypeSearchList: [],
		changeTypeOrtherSerchList: [],
		ortherList: [],
		defaultProps: {
		  children: "Children",
		  label: "ChangeName",
		},
		treeDataLeft: [], // 左侧树数据
		treeDataRight: [], // 右侧树数据
	  };
	},
	computed: {
	  selectedLabels: {
		get() {
		  let arr = [];
		  this.allChangeTypeList.forEach((item) => {
			this.selectedItems.forEach((ele) => {
			  if (item.ChangeType == ele) {
				arr.push(item.ChangeName);
			  }
			});
		  });
		  return arr.join(",");
		},
		set() {},
	  },
	},
	created() {
	  this.app = app;
	  this.pagesize = 15;
	  var startOfDay = new Date();
	  startOfDay.setHours(0, 0, 0, 0);
	  var endOfDay = new Date();
	  endOfDay.setHours(23, 59, 59, 999); // 设置时间为 23:59:59
	  this.filters.date = [startOfDay, endOfDay];
	  this.getChannel(this.filters.SellerId);
	  if (this.$route.query.UserId) {
		this.filters.UserId = this.$route.query.UserId;
	  }
	  if (this.extraParams && this.extraParams.UserId) {
		this.filters.UserId = this.extraParams.UserId;
	  }
	  this.handleQuery();
	//   this.getAllChangeType();
	//   this.getAllChangeTypeSearch();
	},
	methods: {
	  
	  handleQuery(value) {
		this.page = value ? value : 1;
		this.getRecordList();
	  },
	  handleSizeChange(val) {
		this.pagesize = val;
		this.getRecordList();
	  },
	  handleCurrentChange(val) {
		this.page = val || 1;
		if (typeof this.page != "number") this.page = 1;
		this.getRecordList();
	  },
	  // 获取列表
	  getRecordList() {
		let data = {
		  page: this.page,
		  pagesize: this.pagesize,
		  SellerId: Number(this.filters.SellerIds),
		  ChannelId:  this.filters.ChannelId ==null || this.filters.ChannelId.length== 0 ?  0 :this.filters.ChannelId[0],
		  UserId: Number(this.filters.UserId),
		//   Reason: [...this.selectedItems],
		//   Export: this.Export,
		};

		if (this.filters.date) {
		  data.StartTime = app.getTimeStamp(this.filters.date[0]);
		  data.EndTime = app.getTimeStamp(this.filters.date[1]);
		} else {
		  data.StartTime = 0;
		  data.EndTime = 0;
		}
		this.Export = 0;
		app.post("/user/withdrawliushui_log", data, (result) => {
		  if (data.Export != 1) {
			this.table_data = result.data.data;
			this.total = result.data.total;
			this.totalCount = result.data.totalamount;
		  } else {
			window.open(this.$global.baseURL + result.data.filename);
		  }
		});
	  },
  
	  // 合计
	  getSummaries(param) {
		// const { columns } = param;
		// const sums = [];
		// columns.forEach((column, index) => {
		//   if (column.property == "Id") {
		// 	sums[index] = "合计";
		//   } else if (column.property == "Amount") {
		// 	sums[index] = app.getNumDecimal(this.totalCount.TotalAmount);
		//   } else if (column.property == "BeforeAmount") {
		// 	sums[index] = app.getNumDecimal(this.totalCount.TotalBeforeAmount);
		//   } else if (column.property == "AfterAmount") {
		// 	sums[index] = app.getNumDecimal(this.totalCount.TotalAfterAmount);
		//   }
		// });
		// return sums;
	  },
	  // 类型显示
	  backLabelValue(val) {
		return this.allChangeTypeList.find((item) => item.ChangeType == val)
		  ?.ChangeName;
	  },

	},
  };
  </script>
  <style scoped>
  .category-cell {
	display: flex;
	flex-direction: column;
	margin-bottom: 10px;
  }
  
  .category-cell .label {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin-bottom: 4px;
	font-size: 14px;
  }
  
  .category-cell .categorys {
	padding: 10px 16px;
	box-sizing: border-box;
	border: 1px dashed #ccc;
	display: flex;
	flex-wrap: wrap;
  }
  .category-cell .categorys.max {
	max-height: 300px;
	overflow-y: scroll;
  }
  
  .category-cell .categorys .el-checkbox {
	min-width: 175px;
	margin-right: 6px;
  }
  .category-cell .categorys.max .el-checkbox {
	width: 45%;
  }
  .tree-container {
	display: flex;
	width: 100%;
  }
  .tree-column {
	flex: 1;
  }
  </style>
  